export const mascotStyles = `
  .qaw-root {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    position: relative;
  }
  /* collapsed "Yardım ister misin?" re-open pill above the mascot */
  .qaw-help-pill {
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    white-space: nowrap;
    cursor: pointer;
    font-family: var(--font-sans);
    font-size: var(--fs-md);
    font-weight: 700;
    color: var(--brand-dark);
    padding: 6px 14px;
    border-radius: var(--rad-catchup-full);
    background: var(--glass-popover-bg, rgba(255, 253, 250, 0.85));
    -webkit-backdrop-filter: var(--glass-popover-filter);
    backdrop-filter: var(--glass-popover-filter);
    border: 1px solid var(--glass-border-top, rgba(255, 255, 255, 0.8));
    box-shadow: 0 8px 18px -8px rgba(15, 72, 89, 0.4);
    transition: transform var(--duration-base) var(--ease-standard);
  }
  .qaw-help-pill:hover { transform: translateX(-50%) translateY(-2px); }
`;
